import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getPdfBillProcess } from '../../../../actions';

const BillingPdfButton = ({ dispatchGetPdfBillProcess, ticketId, loading }) => {
  if (!ticketId) return null;

  const handleDownload = (e) => {
    e.stopPropagation();
    if (!ticketId || loading) return;
    dispatchGetPdfBillProcess(ticketId);
  };

  return (
    <div
      tabIndex={0}
      role="button"
      onClick={handleDownload}
      onKeyDown={(e) => {
        if ((e.key === 'Enter' || e.key === ' ') && !loading) {
          e.preventDefault();
          handleDownload(e);
        }
      }}
      title={loading ? 'Cargando...' : 'Descargar PDF de la Facturación'}
      style={{
        cursor: loading ? 'not-allowed' : 'pointer',
        width: '48px',
        height: '48px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        border: '1px solid #dc3545',
        backgroundColor: loading ? '#f8d7da' : 'white',
        color: '#dc3545',
        fontSize: '11px',
        transition: 'all 0.2s ease-in-out',
        opacity: loading ? 0.6 : 1,
        pointerEvents: loading ? 'none' : 'auto',
      }}
    >
      {loading ? (
        <div
          className="spinner-border text-danger"
          role="status"
          style={{ width: '20px', height: '20px' }}
        >
          <span className="visually-hidden">...</span>
        </div>
      ) : (
        <>
          <i
            className="fa fa-file-pdf-o"
            style={{
              fontSize: '16px',
              marginBottom: '3px',
              color: '#dc3545',
            }}
          />
          <span style={{ color: '#dc3545', fontWeight: 'bold' }}>PDF</span>
        </>
      )}
    </div>
  );
};

BillingPdfButton.propTypes = {
  dispatchGetPdfBillProcess: PropTypes.func.isRequired,
  ticketId: PropTypes.string,
  loading: PropTypes.bool,
};

BillingPdfButton.defaultProps = {
  ticketId: null,
  loading: false,
};

// Estado de carga — igual que en CDR
const mapStateToProps = ({ AccountingUnit }) => ({
  loading: !AccountingUnit.Billing.getIn(['current', 'activity']).isEmpty(),
});

const mapDispatchToProps = {
  dispatchGetPdfBillProcess: getPdfBillProcess,
};

export default connect(mapStateToProps, mapDispatchToProps)(BillingPdfButton);
